/**
 * File: UnreadBadge.tsx
 * Path: apps/admin/src/modules/layout/components/UnreadBadge.tsx
 * Description: The unread count on the Notifications menu item, and a dot
 * for the phone's More button.
 */

import React from "react";
import { cn } from "@idk/utils";
import { useInbox } from "@/shared/hooks/useNotificationsState";

export const UnreadBadge: React.FC<{ className?: string }> = ({ className }) => {
  const { unread } = useInbox();
  if (unread === 0) return null;
  return (
    <span
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-none bg-primary px-stack-xs text-xs font-black text-primary-foreground",
        className,
      )}
      aria-label={`${unread} unread`}
    >
      {unread > 9 ? "9+" : unread}
    </span>
  );
};

export const UnreadDot: React.FC<{ className?: string }> = ({ className }) => {
  const { unread } = useInbox();
  if (unread === 0) return null;
  return (
    <span
      className={cn("h-2 w-2 rounded-none bg-primary", className)}
      aria-label={`${unread} unread notifications`}
    />
  );
};
